import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation AnalyzeZones($params: AnalyzeZonesInput!) {
    analyzeZones(params: $params) {
      id
      rasterUrl
    }
  }
`;

export interface ZoneAnalysisParams {
  sourceRaster: string;
  bins: NdviRasterBins;
}

export type ZoneAnalysisResult = {
  id: string;
  rasterUrl: string;
};

interface Renders {
  execute: (params: ZoneAnalysisParams) => void;
  processing: boolean;
}

type ChildrenFn = (renders: Renders) => React.ReactNode;

interface Props {
  onCompleted: (result: ZoneAnalysisResult) => void;
  onError?: (error: any) => void;
  children: ChildrenFn;
}

const AnalyzeZonesProvider: React.StatelessComponent<Props> = (
  props: Props
) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => props.onCompleted(data.analyzeZones)}
      onError={props.onError}
    >
      {(mutateFn, result) =>
        props.children({
          processing: result.loading,
          execute: params => mutateFn({ variables: { params } })
        })
      }
    </AuthorizedMutation>
  );
};

export default AnalyzeZonesProvider;



// WEBPACK FOOTER //
// ./src/providers/AnalyzeZonesProvider.tsx